import { Link } from "react-router-dom";

const API_ORIGIN = process.env.REACT_APP_API_ORIGIN || "http://127.0.0.1:8000";

function normaliseImage(src) {
  if (!src) return "/images/product-electronics.svg";
  if (src.startsWith("http://") || src.startsWith("https://") || src.startsWith("/images/")) return src;
  if (src.startsWith("/media/")) return `${API_ORIGIN}${src}`;
  if (src.startsWith("media/")) return `${API_ORIGIN}/${src}`;
  return src;
}

export default function ProductCard({ item, product }) {
  const data = item || product || {};
  const image = normaliseImage(data.image_src || data.image_url || data.image);
  const price = data.price_range || `${data.currency || "US$"}${data.price_min || "0"}-${data.price_max || "0"}`;
  const slug = data.slug || data.code || data.id || "";

  return (
    <Link to={slug ? `/products/${slug}` : "/search"} className="product-card product-card--compact product-card--clickable marketplace-product-card-v2">
      <div className="product-card__image marketplace-product-card-v2__image">
        <img src={image} alt={data.title || "Marketplace product"} loading="lazy" />
        <span className="marketplace-badge">{data.category_name || "Marketplace"}</span>
      </div>
      <div className="product-card__body marketplace-product-card-v2__body">
        <h3>{data.title || "Marketplace product"}</h3>
        <div className="price-line">{price}</div>
        <div className="meta-line">{data.brand ? `${data.brand} · ` : ""}{data.moq_text || "MOQ available"}</div>
        <div className="marketplace-rating-line" aria-label={Number(data.review_count || 0) ? `${Number(data.rating || 0).toFixed(1)} out of 5 stars` : "No reviews yet"}>{Number(data.review_count || 0) ? <><span>★</span><strong>{Number(data.rating || 0).toFixed(1)}</strong><em>({data.review_count})</em></> : <em>New listing</em>}</div>
        <div className="seller-line"><strong>{data.verified_badge || "Verified"}</strong><span>{data.seller_years || 1} yr · {data.country || "ZW"}</span></div>
        <div className="seller-contact-row">
          <span>{data.seller_display || data.seller_name || "Seller"}</span>
          <span>Contact through TAZY CART</span>
        </div>
      </div>
    </Link>
  );
}
